import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import VerifiedBadge from "./VerifiedBadge";
import StarRating from "./StarRating";

export default function FreelancerCard({ f }) {
  return (
    <Link to={`/freelancer/${f.username}`} className="card-flat block" data-testid={`freelancer-card-${f.username}`}>
      <div className="flex items-center gap-3">
        {f.avatar
          ? <img src={f.avatar} alt={f.name} className="w-12 h-12 rounded-full object-cover" />
          : <div className="w-12 h-12 rounded-full bg-brand-tint text-brand grid place-items-center font-display font-black">{(f.name || "?")[0]}</div>}
        <div>
          <p className="font-semibold flex items-center gap-1 text-foreground">
            {f.name}
            {f.verified && <VerifiedBadge size={14} />}
            {f.availability && <CheckCircle2 className="w-4 h-4 text-emerald-500" />}
          </p>
          <p className="text-xs text-muted-foreground">@{f.username}</p>
          {f.rating && <StarRating rating={f.rating} count={f.rating_count} size="sm" />}
        </div>
      </div>
      <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{f.about || "Freelancer on EarnMate."}</p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {(f.specializations || []).slice(0, 3).map(s => <span key={s} className="text-xs px-2.5 py-1 rounded-full bg-brand-tint text-brand font-mono">{s}</span>)}
      </div>
      <div className="mt-3 flex items-center justify-between text-xs">
        <span className="label-eyebrow text-muted-foreground">{f.experience_level || "—"}</span>
        <span className="text-foreground">{f.pricing || ""}</span>
      </div>
    </Link>
  );
}
